module.exports = __webpack_public_path__ + "static/media/payment-history-icon.bb7ee5d5.svg";